module.exports = __webpack_public_path__ + "img/a1.31df0663.png";